/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEmbeddingsListModels } from "../../funcs/llmEmbeddingsListModels.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEmbeddingModelsRequest$inboundSchema,
};

export const tool$llmEmbeddingsListModels: ToolDefinition<typeof args> = {
  name: "llm-embeddings-list-models",
  description: `List available embedding models

Returns a list of available embedding models with their limits. Use this endpoint to discover which models are available and their constraints (batch size, input length) before making embedding requests.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEmbeddingsListModels(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
